import React from "react";
import Link from "@qlik/qlik/src/components/Link";
import * as styles from "./styles.module.css";
import isNoItem from "@qlik/qlik/src/lib/util/isNoItem";

/**
 * FooterBottomMenu component
 * This component renders the bottom links in the footer.
 * Each link is rendered with a RichLink component.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {Array} props.bottomLinks - The array of bottom links to be rendered.
 * Each link object should have an id, url, pageLink, and title.
 *
 * @returns {React.Element} The rendered FooterBottomMenu component.
 */

const FooterBottomMenu = ({ bottomLinks }) => {
    const linkClasses = "lg:inline-block opacity-70 hover:opacity-100 transition-opacity";

    // Filter out the links containing "[[noitem]]" in the title field
    const footerLinks = bottomLinks?.filter((footerItem) => !isNoItem(footerItem?.title));

    // Find the index of the item (e.g., 3)
    const doNotShareIndex = footerLinks.findIndex(
        (item) => item.name === "Footer: Privacy Menu - Do not Share my info"
    );

    return (
        <ul className={`leading-tight ${styles.footerBottomMenu}`}>
            {footerLinks.map((bottomLink, index) => (
                <li className="inline text-xs font-semibold" key={bottomLink.id}>
                    {index === doNotShareIndex ? (
                        <a
                            onClick={() => window?.Optanon?.ToggleInfoDisplay()}
                            className={linkClasses}
                            data-ignore-geolocation="true"
                            style={{ cursor: "pointer" }}
                        >
                            {bottomLink.title}
                        </a>
                    ) : (
                        <Link to={bottomLink?.pageLink?.slug ?? bottomLink?.externalUrl} className={linkClasses}>
                            {bottomLink.title}
                        </Link>
                    )}
                    {/* Render a separator after each link except the last one */}
                    {index !== footerLinks.length - 1 && (
                        <span aria-hidden="true" className="lg:inline-block mx-4.25 opacity-70">
                            {" "}
                            /{" "}
                        </span>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default FooterBottomMenu;
